__turbopack_context__.v({
  "linkTileContainer": "LinkTiles-module-scss-module__Ranzpa__linkTileContainer",
  "linkTileItem": "LinkTiles-module-scss-module__Ranzpa__linkTileItem",
  "linkTileItemWrapper": "LinkTiles-module-scss-module__Ranzpa__linkTileItemWrapper",
});
